<template>
    <div>
        <v-data-table
                :headers="headers"
                :items="projects"
                :search="search"
                :loading="loading"
        >
            <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.displayName }}</td>
                <td class="text-xs-left">{{ $t(`projects.types.${props.item.type}`) }}</td>
                <td class="text-xs-left">
                    <v-btn flat icon @click="openDialog(props.item)">
                        <v-icon>add_box</v-icon>
                    </v-btn>
                </td>
            </template>
        </v-data-table>
        <firebase-project-form v-on:close="closeForm()" :open="openForm" :project="selectedProject"></firebase-project-form>
    </div>
</template>

<script>
    import FirebaseProjectForm from "./dialog/FirebaseProjectForm";
    export default {
        name: "GcpProjectTable",
        components: { FirebaseProjectForm },
        props: {
            search: {
                type: String,
            },
            projects: {
                type: Array,
                required: true,
            },
            loading: {
                type: Boolean,
                required: true,
            }
        },
        data() {
            return {
                headers: [
                    { text: this.$t('projects.displayName'), value: 'displayName' },
                    { text: this.$t('projects.types.label'), value: 'type' },
                    { text: this.$t('projects.actions'), value: 'id', sortable: false }
                ],
                form: false,
                selectedProject: {},
                openForm: false,
            }
        },
        methods: {
            openDialog(project) {
                this.selectedProject = project;
                this.openForm = true;
            },
            closeForm() {
                this.openForm = false;
                this.$emit('close');
            }
        }
    }
</script>
